<template>
  <div>
    <Table highlight-row row-key="id" :columns="columns" :data="list" @on-row-click="handleOnRowClick">
      <template v-if="item.slot" v-for="(item, i) in columns"  slot-scope="{ row, index }" :slot="item.slot">
        <slot :name="item.slot" :data="{ row, index }"></slot>
      </template>
    </Table>
    <div class="mg-bottom20"></div>

    <Page v-if="showPage" :current="search.page" :total="total" @on-change="getLoad" />
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {
    columns: Array,
    requestUrl: String,
    showPage: Boolean,
    params: {
      type: Object,
      default () {
        return {};
      }
    }
  },
  data () {
    return {
      search: {
        page: 1,
        limit: 10
      },
      list: [],
      total: 0
    };
  },
  mounted () {
    this.requestUrl && this.reSearch(this.params);
  },
  methods: {
    getLoad (page) {
      if (page) this.search.page = page;
      this.$base.showLoading();
      this.$request.sendPost(
        this.requestUrl,
        this.search,
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.alertErr(error.errmsg);
          data.list.forEach((e, i) => {
            e.id = i + 1;
            e._showChildren = true;
            if (e.children && e.children.length > 0) {
              e.children.forEach((t, i) => {
                t.id = e.id + "00" + (i + 1)
              })
            }
          });
          this.list = data.list;
          this.total = Number(data.total.total);
        }
      );
    },
    reSearch (params) {
      this.search = { page: 1, limit: 10, ...params };
      this.getLoad();
    },
    handleOnRowClick (item) {
      this.$emit("on-row-click", item);
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ivu-table th {
  background-color: #09684a;
  color: #fff;
  font-size: 15px;
  padding: 10px 0;
}
/deep/ .ivu-table td {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/myTable.vue